import { render, staticRenderFns } from "./sort-column.vue?vue&type=template&id=6c9c6aac&"
import script from "./sort-column.vue?vue&type=script&lang=js&"
export * from "./sort-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports